const statusButtonClass: string = "js-talk-status";
const activeClass: string = "c-talk__status__button--active";
document.addEventListener("click", (event: any) => {
  const statusButton: HTMLElement = event.target.closest(`.${statusButtonClass}`)!;
  if (statusButton) {
    const activeElm: HTMLElement = document.querySelector(`.${activeClass}`)!;
    if (activeElm) {
      activeElm.classList.remove(activeClass);
    }
    setTimeout(()=>{
      statusButton.classList.add(activeClass);
    },100);
  }
});
